<template>
  <div>

    <div v-if="$isDataLoaded(course, groups)">
      <web-ide></web-ide>

    </div>

    <portal-target class="modal-portal" name="modal"></portal-target>
  </div>

</template>

<script>
import WebIde from '@/components/classroom/web/WebIde'
import IClassroom from '@/components/classroom/lib/IClassroom'
import Cookie from '@/common/utils/cookies'

const IDE = window['IDE']

export default {
  components: { WebIde },
  data () {
    return {
      IDE: IDE,
      loggedIn: false
    }
  },
  async mounted () {
    await this.login()
  },
  computed: {
    courseId () {
      const urlParams = new URLSearchParams(window.location.search)
      return urlParams.get('id')
    },
    course () {
      if (this.loggedIn) {
        const course = this.$api.getData('/student/courses/' + this.courseId)
        // 处理课程结束的情况
        if (course.catch) {
          course.catch(() => {
            this.$noty.warning('尚未选课，2 秒后返回上一页')
            setTimeout(() => {
              window.history.back()
            }, 2000)
          })
        }

        return course
      }
      return null
    },
    groups () {
      if (this.loggedIn) {
        let groups = this.$api.getData('/student/courses/' + this.courseId + '/groups')
        if (this.$isDataLoaded(groups, this.course) && this.course) {
          if (groups.parsed) {
            return groups
          }

          groups.parsed = true
          groups = groups.filter(g => g.subtype === 'igroup').sort((a, b) => a.index - b.index)
          let lastStudyGroup = groups[0]
          let chapter = ''
          let index = 0
          groups.forEach((group, i) => {
            group.lock = true
            if (!group.chapter) {
              group.index = index
            } else if (group.chapter !== chapter) {
              chapter = group.chapter
              group.index = ++index
            } else {
              group.chapter = ''
              group.index = index
            }
            if (i <= 1) {
              group.lock = false
            }
            if (i >= 1 && groups[i - 1].commits) {
              group.lock = false
            }
            if (group.commits && group.commits.commit_at) {
              group.lock = false
              lastStudyGroup = group
            }
            group.done = group.commits && group.commits.commit_at
          })
          this.$nextTick(() => {
            IClassroom.enterCourse({
              _id: this.course._id,
              name: this.course.name,
              groups: groups
            })
            if (!IClassroom.group && lastStudyGroup) {
              this.$noty.info('已进入最新学习章节')
              IClassroom.enterGroup(lastStudyGroup)
            }
          })
          return groups
        }
        return null
      }
      return null
    }
  },
  methods: {
    async login () {
      let token = Cookie.get('token')

      if (window.location.host === 'localhost:8081') {
        const loginData = await this.$api.put('/session', {
          email: 'zhanghang@python123.io', pass: '123123123'
        })

        // todo: 获得登录状态
        token = loginData.token
      }

      if (!token) {
        window.location.href = 'https://python123.io/index/login'
        return
      }

      this.$api.setToken(token)
      this.loggedIn = true
      IClassroom.login(token)
      await IDE.setSetting('token', token)
    },
    async getCourse (courseId) {
      this.error = ''
      try {
        const course = await this.$api.get('/student/courses/' + courseId)
        if (course.type !== 'iclass') {
          return
        }

        await IClassroom.setIoType('message')
        let courseMeta = await IClassroom.callRemote('course.meta', courseId) || {}

        let counter = 1
        courseMeta.chapters.forEach((chapter, index) => {
          chapter.items && chapter.items.forEach((item) => {
            item.id = counter++
          })
          if (index === 0) {
            chapter.index = 0
          } else if (chapter.type === 'title') {
            chapter.index = courseMeta.chapters[index - 1].index + 1
          } else {
            chapter.index = courseMeta.chapters[index - 1].index
          }

          if (index > 12) {
            chapter.lock = true
          }
        })
        IDE.setCourseInfo({
          id: course._id,
          name: course.name,
          chapters: courseMeta.chapters
        })

      } catch (e) {
        console.log(e)
        this.error = '网络错误，请检查您的网络设置'
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.modal-portal {
  z-index $zIndexModal
}
</style>
